import { render, staticRenderFns } from "./AssignmentTabs.vue?vue&type=template&id=486d790d&"
import script from "./AssignmentTabs.vue?vue&type=script&lang=js&"
export * from "./AssignmentTabs.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports